import Storage from '@comm/utils/storagehandle'
const state = {
  matchInfo: Storage.getItem('matchInfo') || null,
  activeMenu: Storage.getItem('activeMenu') || 0,
  miniCode: Storage.getItem('miniCode') || null
}

const getters = {
  matchInfo: state => state.matchInfo,
  activeMenu: state => state.activeMenu,
  miniCode: state => state.miniCode
}

const actions = {

}

const mutations = {
  MATCH_CHANGE_MATCH_INFO (state, data) {
    state.matchInfo = data
    Storage.setItem('matchInfo', state.matchInfo)
  },
  MATCH_CHANGE_MINI_CODE (state, data) {
    state.miniCode = data
    Storage.setItem('miniCode', state.miniCode)
  },
  MATCH_CHANGE_ACTIVE_MENU (state, data) {
    state.activeMenu = data
    Storage.setItem('activeMenu', state.activeMenu)
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/daoba-match/store/modules/match.js